import firebase from "firebase";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyAnmXmROkS6ES7A66rUPWTDKkHayDQe3Zw",
  authDomain: "english-word-35d70.firebaseapp.com",
  databaseURL: "https://english-word-35d70.firebaseio.com",
  projectId: "english-word-35d70",
  storageBucket: "english-word-35d70.appspot.com",
  messagingSenderId: "594326563882",
  appId: "1:594326563882:web:f339e8c3ab12692c61e753",
  measurementId: "G-8ERM3K8Y0S",
};

if (process.env.NODE_ENV === "production") {
  firebase.initializeApp(firebaseConfig);
} else {
  if (process.env.VUE_APP_FIREBASE_ENV === "local") {
    var request = new XMLHttpRequest();
    request.open("GET", "/__/firebase/init.json", false);
    request.send(null);
    if (request.status === 200) {
      const configJson = JSON.parse(request.responseText);
      firebase.initializeApp(configJson);
      firebase.firestore().settings({
        host: "localhost:8080",
        ssl: false,
      });
    } else {
      console.log("Failed to setup config file...");
    }
  } else {
    // TODO: not production and not local env... It's will be stg!
    // Currently, using the production one but let's create a different project
    firebase.initializeApp(firebaseConfig);
  }
}

export const fb = firebase;
export const db = firebase.firestore();
export const auth = firebase.auth();
